import remote from '../utils/remote';

/**
 * Handles the number of items to show and enables the loading of more items
 *
 * @param {htmlNode} rootElement The component root node
 * @param {Object} config The component configuration
 */
export default function(rootElement, config) {
  if (!rootElement || !config) {
    return false;
  }

  const itemsContainer = rootElement.querySelector(config.ajax.itemsContainer);
  if (!itemsContainer) {
    console.error('No container element found for ajax content');
    return;
  }

  const loadMoreButton = createLoadMoreButton(rootElement, config);
  itemsContainer.setAttribute('aria-live', 'polite');

  loadMoreButton.loading = false;
  loadMoreButton.addEventListener('click', (e) => {
    e.preventDefault();
    if (loadMoreButton.loading) {
      return;
    }

    const page = parseInt(loadMoreButton.dataset.ajaxPage, 10);
    const url = loadMoreButton.dataset.ajaxUrl.replace('${page}', page + 1);

    startLoading(loadMoreButton);
    remote(url).then(json => {
      itemsContainer.insertAdjacentHTML('beforeend', json.items);

      if (!json.hasNext || json.itemsReturned < config.ajax.itemsToIncrement) {
        loadMoreButton.setAttribute('aria-hidden', true);
        showFallbackMessage(itemsContainer, config);
      }

      loadMoreButton.setAttribute('data-ajax-page', json.page);
      endLoading(loadMoreButton, config);
    }).catch(error => {
      rootElement.querySelector('[data-role="load-more-button"]').ariaHidden = true;
      showFallbackMessage(itemsContainer, config);
      console.error(error);
    });
  });
}

/**
 * Adds the loading properties for a button
 *
 * @param {htmlNode} button
 */
function startLoading(button) {
  button.loading = true;
  button.classList.add('loading');
  button.setAttribute('aria-label', button.getAttribute('data-loading-text'));
  button.setAttribute('role', 'progressbar');
}

/**
 * Removes the loading properties of a button
 *
 * @param {htmlNode} button
 */
function endLoading(button, config) {
  button.classList.remove('loading');
  button.removeAttribute('aria-label');
  button.removeAttribute('role');
  button.loading = false;
  config.ajax.href ? button.href = config.ajax.href.replace('${page}', button.getAttribute('data-ajax-page')) : false;
}

/**
 * Creates the load more button and appends it to the component
 *
 * @param {htmlNode} rootElement The component root node
 * @param {Object} config The component configuration
 * @return {htmlNode}
 */
function createLoadMoreButton(rootElement, config) {
  const button = document.createElement(config.ajax.href ? 'a' : 'button');
  button.setAttribute('data-role', 'load-more-button');
  button.setAttribute('aria-controls', config.ajax.itemContainerId);
  button.setAttribute('data-ajax-page', config.ajax.currentPage || 1);
  button.setAttribute('data-ajax-url', config.ajax.url);
  button.setAttribute('data-loading-text', config.loadingText);
  button.className = 'sdc-site-load-more__button';
  button.innerText = config.loadMoreButtonText;
  config.ajax.href ? button.setAttribute('href', config.ajax.href.replace('${page}', button.getAttribute('data-ajax-page'))) : false;

  rootElement.appendChild(button);
  return button;
}

function showFallbackMessage(itemsContainer, config) {
  const msg = `<div class='sdc-site-load-more__message-line-break'></div><div class="sdc-site-load-more__message">${config.noMoreItemsText}</div>`;
  itemsContainer.insertAdjacentHTML('beforeend', msg);
}
